"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Offers_1 = require("./Offers");
exports.default = Offers_1.Offers;
